export default function dataGenerator(lng) {
	const cards_1 = [
		{
			products_cod: ["AUN20000FRLL0"],
			products_type: ["Ø 2 mm"],
		},
		{
			products_cod: ["AUN22SHODR000", "AUN28SHODR000", "AUN32SHODR000", "AUN34SHODR000", "AUN37SHODR000", "AUN41SHODR000", "AUN46SHODR000", "AUN56SHODR000"],
			products_type: [" Ø 2.2 mm", "Ø 2.8 mm", "Ø 3.2 mm", "Ø 3.4 mm", "Ø 3.7 mm", "Ø 4.1 mm", "Ø 4.6 mm", "Ø 5.6 mm"],
		},
		{
			products_cod: ["", "", "AUN22000DR000", "AUN28000DR000", "AUN32000DR000", "AUN34000DR000", "AUN37000DR000", "AUN41000DR000", "AUN46000DR000", "AUN56000DR000"],
			products_type: ["", "", " Ø 2.2 mm", "Ø 2.8 mm", "Ø 3.2 mm", "Ø 3.4 mm", "Ø 3.7 mm", "Ø 4.1 mm", "Ø 4.6 mm", "Ø 5.6 mm"],
		},
		{
			products_cod_1: ["AIF33080FRFI0", "AIF33100FRFI0", "AIF33115FRFI0", "AIF33130FRFI0", "AIF33150FRFI0", "AIF37080FRFI0", "AIF37100FRFI0", "AIF37115FRFI0", "AIF37130FRFI0", "AIF37150FRFI0"],
			products_cod_2: ["AIF42080FRFI0", "AIF42100FRFI0", "AIF42115FRFI0", "AIF42130FRFI0", "AIF42150FRFI0", "AIF50080FRFI0", "AIF50100FRFI0", "AIF50115FRFI0", "AIF50130FRFI0", "AIF50150FRFI0"],
			products_type_1: ["Ø 3.3", "Ø 3.3", "Ø 3.3", "Ø 3.3", "Ø 3.3", "Ø 3.75", "Ø 3.75", "Ø 3.75", "Ø 3.75", "Ø 3.75"],
			products_type_2: ["Ø 4.2", "Ø 4.2", "Ø 4.2", "Ø 4.2", "Ø 4.2", "Ø 5", "Ø 5", "Ø 5", "Ø 5", "Ø 5"],
			products_detail_1: ["h.8", "h.10", "h.11.5", "h.13", "h.15", "h.8", "h.10", "h.11.5", "h.13", "h.15"],
			products_detail_2: ["h.8", "h.10", "h.11.5", "h.13", "h.15", "h.8", "h.10", "h.11.5", "h.13", "h.15"],
		},
		{
			products_cod: ["AUN35000FO000", "UN35LARFO000", "AUN00000FOGU0"],
			products_type: lng === "es" ?
				["NORMAL", "LARGA", "GUÍA"] :
				["NORMALE", "WIDE", "GUIDE"],
		},
		{
			products_cod: ["AUN3505000ST0", "AUN3507000ST0", "AUN3508000ST0", "AUN3510000ST0", "AUN3511500ST0", "AUN3513000ST0", "AUN3515000ST0"],
			products_type: ["Ø3.5 mm", "Ø3.5 mm", "Ø3.5 mm", "Ø3.5 mm", "Ø3.5 mm", "Ø3.5 mm", "Ø3.5 mm"],
			products_detail: ["L. 5 mm", "L. 7 mm", "L. 8 mm", "L. 10 mm", "L. 11.5 mm", "L. 13 mm", "L. 15 mm"]
		},
		{
			products_cod: ["AUN5505000ST0", "AUN5507000ST0", "AUN5508000ST0", "AUN5510000ST0", "AUN5511500ST0", "AUN5513000ST0", "AUN5515000ST0"],
			products_type: ["Ø5.5 mm", "Ø5.5 mm", "Ø5.5 mm", "Ø5.5 mm", "Ø5.5 mm", "Ø5.5 mm", "Ø5.5 mm"],
			products_detail: ["L. 5 mm", "L. 7 mm", "L. 8 mm", "L. 10 mm", "L. 11.5 mm", "L. 13 mm", "L. 15 mm"]
		},
	]
	const cards_2 = [
		{
			products_cod: ["AST00LNGAPCRI"],
			products_type: [""],
			products_header: ["L. 19 mm"],
		},
		{
			products_cod: ["AST00000APCRI"],
			products_type: [""],
			products_header: ["L. 13 mm"],
		},
		{
			products_cod: ["AST00000CMCE0"],
			products_type: [""],
			products_header: ["L. 3 mm"],
		},
		{
			products_cod: ["AST00160CBITK"],
			products_type: [""],
			products_header: ["L. 14 mm"],
		},
		{
			products_cod: ["AST00090CBITK"],
			products_type: [""],
			products_header: ["L. 4.7 mm"],
		},
		{
			products_cod: ["AST12000APCAB", "AST00000PRCAI"],
			products_type: ["Ø 1.20", "Ø 1.25"],
			products_header: ["L. 14 mm"],
		},
		{
			products_cod: ["AST12SHOAPCAB", "AST00SHOCMCEK"],
			products_type: ["Ø 1.20", "Ø 1.25"],
			products_header: ["L. 9 mm"],
		},
		{
			products_cod: ["AST12000APCRB", "AST1B000APCRB"],
			products_type: ["Ø 1.20", "Ø 1.25"],
			products_header: ["L. 14 mm"],
		},
		{
			products_cod: ["AST12SHOAPCRB", "AST1BSHOAPCRB"],
			products_type: ["Ø 1.20", "Ø 1.25"],
			products_header: ["L. 8 mm"],
		},
		{
			products_cod: ["AST00000APCRE", ""],
			products_type: ["", ""],
			products_header: ["L. 14 mm"],
		},
		{
			products_cod: ["AST00SHOAPCRE", ""],
			products_type: ["", ""],
			products_header: ["L. 8 mm"],
		},
	]
	const cards_3 = [
		{
			products_cod: ["AST17000CCIP0", "AST20000CCIP0"],
			products_type: ["Ø 1.7 mm", "Ø 2.0 mm"],
		},
		{
			products_cod: ["AST00000SUIP0", ""],
			products_type: ["", ""],
		},
		{
			products_cod: ["AST00000CCDN0"],
			products_type: [""],
			products_header: [""],
		},
		{
			products_cod: ["AST00000CCCR0"],
			products_type: [""],
			products_header: [""],
		},
		{
			products_cod: ["AST00000CHIN0", ""],
			products_type: ["", ""],
		},
		{
			products_cod: ["AST0000000PF0", ""],
			products_type: ["", ""],
		},
	]

	const cards_4 = [
		{
			products_cod: ["AUN41000MU000", "AUN50000MU000"],
			products_type: ["Ø 4.1 mm", "Ø 5 mm"],
		},
	]

	const cards_5 = [
		{
			productCode: ["AUN3508000ST0", "AUN3510000ST0", "AUN3511500ST0", "AUN3513000ST0", "AUN3515000ST0", "AUN5508000ST0", "AUN5510000ST0", "AUN5511500ST0", "AUN5513000ST0", "AUN5515000ST0", "AUN20000FRLL0", "AUN22000DR000", "AUN28000DR000", "AUN32000DR000", "AUN34000DR000", "AUN37000DR000", "AUN41000DR000", "AUN46000DR000", "AUN56000DR000", "AIF33080FRFI0", "AIF33100FRFI0", "AIF33115FRFI0", "AIF33130FRFI0", "AIF33150FRFI0", "AIF37080FRFI0", "AIF37100FRFI0", "AIF37115FRFI0", "AIF37130FRFI0", "AIF37150FRFI0", "AIF42080FRFI0", "AIF42100FRFI0", "AIF42115FRFI0", "AIF42130FRFI0", "AIF42150FRFI0", "AIF50080FRFI0", "AIF50100FRFI0", "AIF50115FRFI0", "AIF50130FRFI0", "AIF50150FRFI0", "AST00000APCRI", "AST00LNGAPCRI", "AST00160CBITK", "AST00000APCRE", "AST12SHOAPCRB", "AST12000APCRB", "AST1BSHOAPCRB", "AST1B000APCRB", "AST20000CCIP0", "AST00000SUIP0", "AST00000CCDN0", "ATY00CYEIF000"],
			productDescription: lng === "es" ?
				["Stop Universal Ø 3.5 mm. L.8 mm.", "Stop Universal Ø 3.5 mm. L.10 mm.", "Stop Universal Ø 3.5 mm. L.11.5 mm", "Stop Universal Ø 3.5 mm. L.13 mm.", "Stop Universal Ø 3.5 mm. L.15 mm.", " Stop Universal Ø 5.5 mm. L.8 mm.", " Stop Universal Ø 5.5 mm. L.10 mm.", " Stop Universal Ø 5.5 mm. L.11.5 mm.", " Stop Universal Ø 5.5 mm. L.13 mm.", " Stop Universal Ø 5.5 mm. L.15 mm.", " Fresa Lanceolada Universal Ø 2 mm.", " Fresa Universal Ø 2.2 mm.", " Fresa Universal Ø 2.8 mm.", " Fresa Universal Ø 3.2 mm.", " Fresa Universal Ø 3.4 mm.", " Fresa Universal Ø 3.7 mm.", " Fresa Universal Ø 4.1 mm.", " Fresa Universal Ø 4.6 mm.", " Fresa Universal Ø 5.6 mm.", " Fresa Cónica IS-FOUR® Ø 3.3 L.08 mm.", " Fresa Cónica IS-FOUR® Ø 3.3 L.10 mm.", " Fresa Cónica IS-FOUR® Ø 3.3 L.11.5 mm.", " Fresa Cónica IS-FOUR® Ø 3.3 L.13 mm.", " Fresa Cónica IS-FOUR® Ø 3.3 L.15 mm.", " Fresa Cónica IS-FOUR® Ø 3.75 L.08 mm.", " Fresa Cónica IS-FOUR® Ø 3.75 L.10 mm.", " Fresa Cónica IS-FOUR® Ø 3.75 L.11.5 mm.", " Fresa Cónica IS-FOUR® Ø 3.75 L.13 mm.", " Fresa Cónica IS-FOUR® Ø 3.75 L.15 mm.", " Fresa Cónica IS-FOUR® Ø 4.2 L.08 mm.", " Fresa Cónica IS-FOUR® Ø 4.2 L.10 mm.", " Fresa Cónica IS-FOUR® Ø 4.2 L.11.5 mm.", " Fresa Cónica IS-FOUR® Ø 4.2 L.13 mm.", " Fresa Cónica IS-FOUR® Ø 4.2 L.15 mm.", " Fresa Cónica IS-FOUR® Ø 5 L.08 mm.", " Fresa Cónica IS-FOUR® Ø 5 L.10 mm.", " Fresa Cónica IS-FOUR® Ø 5 L.11.5 mm.", " Fresa Cónica IS-FOUR® Ø 5 L.13 mm.", " Fresa Cónica IS-FOUR® Ø 5 L.15 mm.", "Llave de Fijación Manual para Implante - HI - Larga.", "Llave de Fijación Manual para Implante - HI - Extra Larga", " Llave de Fijación Contra Angulo para Implante - HI-Larga.", " Llave Multi Uso Recta Larga.", "Llave de Fijación Manual para Prótesis - HI - 1.20 Corta.", "Llave de Fijación Manual para Prótesis - HI - 1.20 Larga", "Llave de Fijación Manual para Prótesis - HI - 1.25 Corta.", "Llave de Fijación Manual para Prótesis - HI - 1.25 Larga.", " Pin de Paralelismo Ø 2 mm. (Cant. 2).", " Indicador de Profundidad.", " Carraca Dinamométrica.", " Caja Quirúrgica y Bandeja."] :
				["Universal Stop Ø 3.5 mm. L.8 mm.","Universal Stop Ø 3.5 mm. L.10 mm.","Universal Stop Ø 3.5 mm. L.11.5 mm.","Universal Stop Ø 3.5 mm. L.13 mm.","Universal Stop Ø 3.5 mm. L.15 mm.","Universal Stop Ø 5.5 mm. L.8 mm.","Universal Stop Ø 5.5 mm. L.10 mm.","Universal Stop Ø 5.5 mm. L.11.5 mm.","Universal Stop Ø 5.5 mm. L.13 mm.","Universal Stop Ø 5.5 mm. L.15 mm.","Universal Lance Drill Ø 2 mm.","Universal Drill Ø 2.2 mm.","Universal Drill Ø 2.8 mm.","Universal Drill Ø 3.2 mm.","Universal Drill Ø 3.4 mm.","Universal Drill Ø 3.7 mm.","Universal Drill Ø 4.1 mm.","Universal Drill Ø 4.6 mm.","Universal Drill Ø 5.6 mm.","Conical Drill IS-FOUR® Ø 3.3 L.08 mm.","Conical Drill IS-FOUR® Ø 3.3 L.10 mm.","Conical Drill IS-FOUR® Ø 3.3 L.11.5 mm.","Conical Drill IS-FOUR® Ø 3.3 L.13 mm.","Conical Drill IS-FOUR® Ø 3.3 L.15 mm.","Conical Drill IS-FOUR® Ø 3.75 L.08 mm.","Conical Drill IS-FOUR® Ø 3.75 L.10 mm.","Conical Drill IS-FOUR® Ø 3.75 L.11.5 mm.","Conical Drill IS-FOUR® Ø 3.75 L.13 mm.","Conical Drill IS-FOUR® Ø 3.75 L.15 mm.","Conical Drill IS-FOUR® Ø 4.2 L.08 mm.","Conical Drill IS-FOUR® Ø 4.2 L.10 mm.","Conical Drill IS-FOUR® Ø 4.2 L.11.5 mm.","Conical Drill IS-FOUR® Ø 4.2 L.13 mm.","Conical Drill IS-FOUR® Ø 4.2 L.15 mm.","Conical Drill IS-FOUR® Ø 5 L.08 mm.","Conical Drill IS-FOUR® Ø 5 L.10 mm.","Conical Drill IS-FOUR® Ø 5 L.11.5 mm.","Conical Drill IS-FOUR® Ø 5 L.13 mm.","Conical Drill IS-FOUR® Ø 5 L.15 mm.","Manual Fix Key for Implant - IH-Long.","Manual Fix Key for Implant - IH-Extra Long.","Contra Angle Fix Key for Implant - IH-Long.","Straight MUA Key Long.","Manual Fix Key for Prosthetic - IH-1.20 Short.","Manual Fix Key for Prosthetic - IH-1.20 Long.","Manual Fix Key for Prosthetic - IH-1.25 Short.","Manual Fix Key for Prosthetic - IH-1.25 Long.","Parallelism Pin Ø 2 mm. (Qty 2).","Depth Gauge.","Torque Ratchet.","Surgical Box and Tray."]
		},
		{
			productCode: ["AUN3505000ST0", "AUN3507000ST0", "AUN5505000ST0", "AUN5507000ST0", "H141A_205018", "AUN22SHODR000", "AUN28SHODR000", "AUN32SHODR000", "AUN34SHODR000", "AUN37SHODR000", "AUN41SHODR000", "AUN46SHODR000", "AUN56SHODR000", "AST00000APCRI", "AST00LNGAPCRI", "AST00160CBITK", "AST00000APCRE", "AST12SHOAPCRB", "AST12000APCRB", "AST1BSHOAPCRB", "AST1B000APCRB", "AST00000CCCR0", "ATY0000EX000"],
			productDescription: lng === "es" ?
				["Stop Universal Ø 3.5 mm. L.5 mm.", "Stop Universal Ø 3.5 mm. L.7 mm.", " Stop Universal Ø 5.5 mm. L.5 mm.", " Stop Universal Ø 5.5 mm. L.7 mm.", " Fresa de Inicio forma de Bola.", " Fresa Corta Ø 2.2 mm.", " Fresa Corta Ø 2.8 mm.", " Fresa Corta Ø 3.2 mm.", " Fresa Corta Ø 3.4 mm.", " Fresa Corta Ø 3.7 mm.", " Fresa Corta Ø 4.1 mm.", " Fresa Corta Ø 4.6 mm.", " Fresa Corta Ø 5.6 mm.", "Llave de Fijación Manual para Implante - HI - Larga.", "Llave de Fijación Manual para Implante - HI - Extra Larga", " Llave de Fijación Contra Angulo para Implante - HI-Larga.", " Llave Multi Uso Recta Larga.", "Llave de Fijación Manual para Prótesis - HE - 1.20 Corta.", "Llave de Fijación Manual para Prótesis - HE - 1.20 Larga.", "Llave de Fijación Manual para Prótesis - HI - 1.25 Corta.", "Llave de Fijación Manual para Prótesis - HI - 1.25 Larga.", " Carraca Reversible.", " Mini Caja Quirúrgica y Bandeja."] :
				["Universal Stop Ø 3.5 mm. L.5 mm.","Universal Stop Ø 3.5 mm. L.7 mm.","Universal Stop Ø 5.5 mm. L.5 mm.","Universal Stop Ø 5.5 mm. L.7 mm.","Ball Drill Start","Short Drill Ø 2.2 mm.","Short Drill Ø 2.8 mm.","Short Drill Ø 3.2 mm.","Short Drill Ø 3.4 mm.","Short Drill Ø 3.7 mm.","Short Drill Ø 4.1 mm.","Short Drill Ø 4.6 mm.","Short Drill Ø 5.6 mm.","Manual Fix Key for Implant - IH-Long.","Manual Fix Key for Implant - IH-Extra Long.","Contra Angle Fix Key for Implant - IH-Long.","Straight MUA Key Long.","Manual Fix Key for Prosthetic - IH-1.20 Short.","Manual Fix Key for Prosthetic - IH-1.20 Long.","Manual Fix Key for Prosthetic - IH-1.25 Short.","Manual Fix Key for Prosthetic - IH-1.25 Long.","Reversible Ratchet.","Mini Surgical Box and Tray."]
		}
	]

	const data = {
		cards_1,
		cards_2,
		cards_3,
		cards_4,
		cards_5
	}
	return data
}